import * as THREE from 'three'
import CameraControls from 'camera-controls';
// import gsap from "https://esm.sh/gsap"; // Required for Path Animation

// TODO: Integrate this in CameraTransition.js? Or find a way to make it work in Hotspots. Basically only need handlePlaceholder click, the rest is already in CameraTransition.js
// TODO: Fix the offset right caused by moving to right so the info points are still clickable.

let greenCameraControls = null;
// let pathMesh = null

CameraControls.install({ THREE: THREE });

export default class Teleports {
    constructor(scene, experience, raycaster, resources, cameraControls, camera, renderer) {
        this.scene = scene;
        this.experience = experience;
        this.raycaster = raycaster;
        this.resources = resources;
        this.cameraControls = cameraControls;
        this.camera = camera;
        this.renderer = renderer;
        this.mouse = new THREE.Vector2();

        // Variable for mobile
        this.alreadyZoomedRiverbank = false;
        this.alreadyZoomedUnderwater = false;

        // To change the clarity of underwater after removing trash
        this.cleanWater = false;
        this.cleanWaterStartTime = 0;
        this.locked = true;

        this.transition = true;

        // Now each placeholder is an object with additional properties and a mesh.
        this.placeholders = [];

        // Check if sidepanel is open or not based on custom event in SidePanel.js
        this.sidepanel = false;
        document.addEventListener("sidePanelOpen", (event) => {
            if (event.detail.open) {
                this.sidepanel = true;
            }

            else {
                this.sidepanel = false;
            }
        });


        document.addEventListener("placeholderClicked", (event) => {
            this.locationId = event.detail.placeholder.id

            // Sets controls and fog system
            if (this.locationId == 'center') {
                // this.controls.truck = false // Gives errors
                // this.cameraControls.zoomTo(this.cameraControls.distance, true); // Ensure zoom is at the current distance
                // this.cameraControls.maxZoom = this.cameraControls.minZoom = 1; // Lock zoom level

                // Controls setup
                this.cameraControls.azimuthRotateSpeed = 0.5
                this.cameraControls.polarRotateSpeed = 0.5
                this.cameraControls.smoothTime = .5

                // Controls range
                this.cameraControls.minPolarAngle = 0;
                this.cameraControls.maxPolarAngle = Math.PI * 2;
                this.cameraControls.minAzimuthAngle = -Infinity
                this.cameraControls.maxAzimuthAngle = Infinity

                // Controls user
                // this.cameraControls.mouseButtons.wheel = this.cameraControls.ACTION.NONE;
                this.cameraControls.mouseButtons.wheel = CameraControls.ACTION.NONE;
                this.cameraControls.mouseButtons.middle = CameraControls.ACTION.NONE;
                this.cameraControls.touches.two = CameraControls.ACTION.NONE;
                this.cameraControls.mouseButtons.right = CameraControls.ACTION.NONE;
                this.cameraControls.touches.three = CameraControls.ACTION.NONE;

                // Fog
                // this.scene.fog = new THREE.Fog(0xeefbff, 20, 85);
                this.scene.fog = new THREE.Fog(0xdbeeff, 5, 65);

            }

            else if (this.locationId == 'riverbank') {
                this.cameraControls.azimuthRotateSpeed = .25
                this.cameraControls.polarRotateSpeed = .25
                this.cameraControls.smoothTime = 0.25

                // Controls range
                this.cameraControls.minPolarAngle = - Math.PI * 4 / 4;
                this.cameraControls.maxPolarAngle = Math.PI * 1.95 / 4;
                this.cameraControls.minAzimuthAngle = -Infinity
                this.cameraControls.maxAzimuthAngle = Infinity

                // Controls user
                this.cameraControls.mouseButtons.wheel = CameraControls.ACTION.NONE;
                this.cameraControls.mouseButtons.middle = CameraControls.ACTION.NONE;
                this.cameraControls.touches.two = CameraControls.ACTION.NONE;
                this.cameraControls.mouseButtons.right = CameraControls.ACTION.NONE;
                this.cameraControls.touches.three = CameraControls.ACTION.NONE;

                // Fog
                // this.scene.fog = new THREE.Fog(0xeefbff, 20, 85);
                this.scene.fog = new THREE.Fog(0xdbeeff, 5, 65);

                // For mobile only
                if (globalThis.mobile) {
                    if (!this.alreadyZoomedRiverbank) {
                        this.cameraControls.zoom(-.5, 0, true)
                        this.alreadyZoomedRiverbank = true;
                    }
                    if (this.alreadyZoomedUnderwater) {
                        this.cameraControls.zoom(.3, 0, true)
                        this.alreadyZoomedUnderwater = false;
                    }
                }

            }

            else if (this.locationId == 'underwater') {
                // Controls setup
                this.cameraControls.azimuthRotateSpeed = 1
                this.cameraControls.polarRotateSpeed = 1
                this.cameraControls.smoothTime = 0.25

                // Controls range
                this.cameraControls.minPolarAngle = Math.PI * 1.6 / 4;
                this.cameraControls.maxPolarAngle = Math.PI * 2.1 / 4;
                // this.cameraControls.minAzimuthAngle = Math.PI * 0.7 / 4
                // this.cameraControls.maxAzimuthAngle = Math.PI * 2.3 / 4

                // Controls user
                this.cameraControls.mouseButtons.wheel = CameraControls.ACTION.NONE;
                this.cameraControls.mouseButtons.middle = CameraControls.ACTION.NONE;
                this.cameraControls.touches.two = CameraControls.ACTION.NONE;
                this.cameraControls.mouseButtons.right = CameraControls.ACTION.NONE;
                this.cameraControls.touches.three = CameraControls.ACTION.NONE;

                // Fog is set in update to animate it
                // Disable transition when starting point is onderwater
                if (event.detail.startLocation == this.locationId) {
                    this.transition = false;
                    this.scene.fog = new THREE.Fog(0x003249, -1, 6);
                    // color:#003249;
                }

                else {
                    this.transition = true;
                }

                // For mobile only
                if (globalThis.mobile) {
                    if (this.alreadyZoomedRiverbank) {
                        this.cameraControls.zoom(.5, 0, true)
                        this.alreadyZoomedRiverbank = false;
                    }
                    if (!this.alreadyZoomedUnderwater) {
                        this.cameraControls.zoom(-.3, 0, true)
                        this.alreadyZoomedUnderwater = true;
                    }
                }
            }

            else if (this.locationId == 'home') {
                // Controls setup
                this.cameraControls.azimuthRotateSpeed = 1
                this.cameraControls.polarRotateSpeed = 1
                this.cameraControls.smoothTime = 0.25

                // Controls range
                this.cameraControls.minPolarAngle = - Math.PI * 4 / 4;
                this.cameraControls.maxPolarAngle = Math.PI * 1.95 / 4;
                this.cameraControls.minAzimuthAngle = -Infinity
                this.cameraControls.maxAzimuthAngle = Infinity
                this.cameraControls.minZoom = 0.02;
                this.cameraControls.boundaryEnclosesCamera = true
                // this.cameraControls.minDistance = 1
                // this.cameraControls.maxDistance = 3

                // Controls user
                this.cameraControls.mouseButtons.wheel = CameraControls.ACTION.DOLLY; // Re-enable zoom with the scroll wheel
                this.cameraControls.mouseButtons.middle = CameraControls.ACTION.DOLLY; // Re-enable dolly with scroll wheel click
                this.cameraControls.touches.two = CameraControls.ACTION.TOUCH_ZOOM_TRUCK; // Re-enable zoom and truck for two-finger touch
                this.cameraControls.mouseButtons.right = CameraControls.ACTION.TRUCK; // Re-enable right-click panning
                this.cameraControls.touches.three = CameraControls.ACTION.TOUCH_TRUCK; // Re-enable three-finger touch panning

                this.cameraControls.setTarget( // Make sure whenever you click either on menu or the marker, that it rotates around the center (orbit center)
                    3.2, .9, 1,
                    true
                );


                // For mobile only
                if (globalThis.mobile) {
                    this.cameraControls.setLookAt(
                        12, 5, 18,
                        3.2, .9, 1,
                        true
                    );
                    if (this.alreadyZoomedRiverbank) {
                        this.cameraControls.zoom(.5, 0, true)
                        this.alreadyZoomedRiverbank = false;
                    }
                    if (this.alreadyZoomedUnderwater) {
                        this.cameraControls.zoom(.3, 0, true)
                        this.alreadyZoomedUnderwater = false;
                    }
                }

                // Create a sphere boundary so you can't zoom out too much, bounces back
                const sphere = new THREE.Sphere(new THREE.Vector3(0, 0, 0), 15);

                // inside your update loop or after controls update
                cameraControls.addEventListener('update', () => {
                    const pos = cameraControls.getPosition(new THREE.Vector3());
                    if (!sphere.containsPoint(pos)) {
                        // project back onto the sphere surface
                        pos.sub(sphere.center).setLength(sphere.radius).add(sphere.center);
                        cameraControls.setPosition(pos.x, pos.y, pos.z, true);
                    }
                });

                // Fog
                // this.scene.fog = new THREE.Fog(0xeefbff, 20, 85);
                this.scene.fog = new THREE.Fog(0xdbeeff, 5, 65);
                // this.scene.fog = new THREE.Fog(0xafd1ef, 5, 65);
            }

            // Hide the locationIndicator if it matches the locationId.
            this.experience.resources.items.mapModel.scene.traverse((child) => {
                if (child.name.includes(this.locationId) && child.type == 'Mesh') { // Mesh is Teleport_Point_{number}_Location_this.locationId
                    child.visible = false;
                }

                else {
                    child.visible = true;
                }
            })

            // if (event.detail.placeholder.info) {
            //     const point = `.point-${event.detail.placeholder.id}`
            //     const sidePanel = document.querySelector(point).parentElement

            //     // console.log(sidePanel)

            //     if (sidePanel) {
            //         this.sidePanel.showContent(sidePanel); // SidePanel
            //     }
            // }

            // // Adding url change on click based on the id
            // updateURL(event.detail.placeholder.id);


            // Save camera position to revert to when info points are closed
            this.cameraControls.saveState()
        });

        // Animate fog
        this.time = experience.time
        this.fogTransitionDuration = 0.5
        this.fogTransitionStart = 0
        this.underwaterFog = false
        this.startTime = 0; // Store the time when the animation starts
        this.totalElapsedTime = 0; // Total elapsed time for animation

        this.resources.on('ready', () => {
            // this.init();
            this.setupPlaceholder();
            this.addEventListeners();
        });


    }

    init() {
        // if (experience.resources.on('ready', () => { // Not sure why not this.experience. Don't need this anymore since I only transition if resources ready already.
        // console.log('yo')

        if (locationId) {
            // experience.resources.items.mapModel.scene.traverse((child) => {
            //     console.log('yo')
            //     // if (child.name.includes(locationId) && child.name.includes('Spawn')) {
            //     //     this.startingPointLocation = child.position;
            //     //     console.log(this.startingPointLocation)
            //     // }
            //     // if (child.name.includes(locationId) && child.type == 'Mesh') {
            //     //     this.startingPointPoint = this.points.find(p => p.id === this.locationId)
            //     // }
            //     // if (child.name.includes(locationId) && child.name.includes('Target')) {
            //     //     this.startingPointTarget = child.position;
            //     //     // console.log(startingPointLocation)
            //     // }
            // })
            // const startingPointPoint = this.points.find(p => p.id === this.locationId)
            // // console.log(startingPoint.position, this.instance.position)
            // Check if startingPoint exists
            if (this.startingPointLocation) {
                this.cameraControls.setLookAt( // This is basically, setPosition (camera position) and setTarget (center)
                    // this.controls.setLookAt( 
                    this.startingPointLocation.x,
                    this.startingPointLocation.y,
                    this.startingPointLocation.z,
                    this.startingPointTarget.x,
                    this.startingPointTarget.y,
                    this.startingPointTarget.z,
                    false
                );
            }
            else if (this.startingPointPoint) {
                this.cameraControls.setTarget(
                    this.startingPointPoint.target.x,
                    this.startingPointPoint.target.y,
                    this.startingPointPoint.target.z
                );
            }


            // Save camera position to revert to when info points are closed
            this.cameraControls.saveState()
        }
    }

    setupPlaceholder() {
        // Traverse the scene and add placeholders with extra data
        this.experience.resources.items.mapModel.scene.traverse((child) => {

            if ((child instanceof THREE.Mesh || child instanceof THREE.Group)) {

                // Floor markers to go to specific wall
                if (child.name.includes("Teleport_Point")) {
                    // Construct the target name based on the placeholder name
                    const targetName = `${child.name}_Target`;
                    const targetObj = this.experience.resources.items.mapModel.scene.getObjectByName(targetName);

                    // If targetObj exists, use its position, otherwise, fall back
                    const targetPos = targetObj ? targetObj.position.clone() : child.position.clone();
                    // Targeting system based on target in Blender
                    let offsetX
                    let offsetZ
                    let teleportOffsetX
                    let teleportOffsetZ
                    let cameraPosition
                    let lookAt
                    let lookDir
                    let basePosition

                    if (child.name.includes("Room_") && child.name.includes('Spot_')) {
                        basePosition = targetObj.position.clone();

                        lookDir = new THREE.Vector3().subVectors(child.position, targetObj.position).normalize();

                        const cameraOffsetDistance = 0.12; // e.g. 1 unit behind
                        cameraPosition = basePosition.clone().add(lookDir.clone().multiplyScalar(-cameraOffsetDistance));
                        cameraPosition.y = 0.30


                        // 3. Compute target point a bit forward in the look direction
                        lookAt = targetObj.position.clone().add(lookDir.clone().multiplyScalar(0.01)); // look 10 units ahead
                        lookAt.y = 0.292

                        this.placeholders.push({
                            position: cameraPosition,
                            target: lookAt,
                            room: false,
                            location: false,
                            // offset: new THREE.Vector3(0.1, 0.1, -0.5),
                            // target: child.position.clone().add(new THREE.Vector3(-0.001, 0.065, -0.001)), // Determines the point the camera looks at from the position
                            // id: 'placeholder',
                            spot: true,
                            // placeholder: true,
                            mesh: child
                        });
                    }

                    else {
                        offsetX = (child.position.x - targetObj.position.x) * .01; // Target in wall sucks for rotation
                        offsetZ = (child.position.z - targetObj.position.z) * .01;

                        teleportOffsetX = (child.position.x - targetObj.position.x) * .5; // - (child.position.x - targetObj.position.x) means the camera goes 100% towards the target. + means 100% away from it.
                        teleportOffsetZ = (child.position.z - targetObj.position.z) * .5;
                    }

                    // Create an offset vector that only affects the x and z components
                    // const teleportOffsetVector = new THREE.Vector3(teleportOffsetX, -targetObj.position.y, teleportOffsetZ);
                    const teleportOffsetVector = new THREE.Vector3(teleportOffsetX, targetObj.position.y / 5, teleportOffsetZ); // No clue why / 5 tbh. Should prob change to targetObj.position.y - child.position.y
                    const offsetVector = new THREE.Vector3(offsetX, targetObj.position.y / 5, offsetZ);


                    // Apply the offset to the target position (cloning targetPos to avoid modifying the original)
                    const teleportOffsetPos = child.position.clone().add(teleportOffsetVector); // Feels higher than it should be.
                    // const teleportOffsetPos = child.position.clone()
                    const offsetPos = child.position.clone().add(offsetVector);

                    // const offsetPos = targetObj.position.clone();

                    // if (child.name.includes("Zaal")) {
                    //     this.placeholders.push({
                    //         room: true,
                    //     })
                    // }

                    if (child.name.includes("Location")) {
                        // Construct the position based on the placeholder name
                        const spawnName = `${child.name}_Spawn`;
                        const spawnObj = this.experience.resources.items.mapModel.scene.getObjectByName(spawnName);

                        // If spawnObj exists, use its position, otherwise, fall back
                        const spawnPos = spawnObj ? spawnObj.position.clone() : child.position.clone();
                        const offsetX = (spawnPos.x - targetObj.position.x) * 0.01;
                        const offsetZ = (spawnPos.z - targetObj.position.z) * 0.01;
                        const teleportOffsetX = (spawnPos.x - targetObj.position.x) * 0.5;
                        const teleportOffsetZ = (spawnPos.z - targetObj.position.z) * 0.5;

                        const teleportOffsetVector = new THREE.Vector3(teleportOffsetX, targetObj.position.y - spawnPos.y, teleportOffsetZ);
                        const offsetVector = new THREE.Vector3(offsetX, targetObj.position.y - spawnPos.y, offsetZ);

                        const teleportOffsetPos = spawnPos.clone().add(teleportOffsetVector);
                        const offsetPos = spawnPos.clone().add(offsetVector);

                        const locationId = child.name.split("_")
                        const locationIdTrunc = locationId[locationId.length - 1]; // Use the last word only

                        // Apply the offset to the target position (cloning targetPos to avoid modifying the original)
                        this.placeholders.push({
                            position: teleportOffsetPos, // This works now
                            target: offsetPos,
                            room: false,
                            location: true,
                            placeholder: false,
                            id: locationIdTrunc,
                            mesh: child
                        })
                    }

                    else {
                        this.placeholders.push({
                            position: cameraPosition,
                            target: lookAt,
                            room: false,
                            location: false,
                            // offset: new THREE.Vector3(0.1, 0.1, -0.5),
                            // target: child.position.clone().add(new THREE.Vector3(-0.001, 0.065, -0.001)), // Determines the point the camera looks at from the position
                            // id: 'placeholder',
                            // spot: true,
                            // placeholder: true,
                            mesh: child
                        });
                    }
                }

                if (child.name.includes("Room_Marker")) {
                    const roomSplit = child.name.split("_")
                    const roomNumber = child.userData.room
                    // const roomNumber = roomSplit[roomSplit.length - 1]; //

                    // Construct the target name based on the placeholder name
                    // const targetName = `${child.name}_Target`;
                    const targetObj = this.experience.resources.items.mapModel.scene.getObjectByName(`Teleport_Point_001_Room_${roomNumber}_Spot_001_Target`);
                    const obj = this.experience.resources.items.mapModel.scene.getObjectByName(`Teleport_Point_001_Room_${roomNumber}_Spot_001`);

                    let basePosition = targetObj.position.clone();

                    let lookDir = new THREE.Vector3().subVectors(obj.position, targetObj.position).normalize();

                    const cameraOffsetDistance = 0.12; // e.g. 1 unit behind
                    let cameraPosition = basePosition.clone().add(lookDir.clone().multiplyScalar(-cameraOffsetDistance));
                    cameraPosition.y = 0.30


                    // 3. Compute target point a bit forward in the look direction
                    let lookAt = targetObj.position.clone().add(lookDir.clone().multiplyScalar(0.01)); // look 10 units ahead
                    lookAt.y = 0.292

                    this.placeholders.push({
                        position: cameraPosition,
                        target: lookAt,
                        room: false,
                        location: false,
                        // offset: new THREE.Vector3(0.1, 0.1, -0.5),
                        // target: child.position.clone().add(new THREE.Vector3(-0.001, 0.065, -0.001)), // Determines the point the camera looks at from the position
                        // id: 'placeholder',
                        spot: true,
                        // placeholder: true,
                        mesh: child
                    });
                }
            }
            if (child.name.includes("Info") && !child.name.includes("Target")) {
                // const idNumber = child.name.replace(/\D/g, "");
                const idSplit = child.name.split("_")
                const roomNumber = idSplit[idSplit.length - 4]; // -4 is room number
                const spotNumber = idSplit[idSplit.length - 2]; // - 2 is the spotNumber associated to the floor spots
                const infoNumber = idSplit[idSplit.length - 1]; // - 1 is the number of the info point.

                const spawn = this.experience.resources.items.mapModel.scene.getObjectByName(`Teleport_Point_001_Room_${roomNumber}_Spot_${spotNumber}`)
                const spawnTarget = this.experience.resources.items.mapModel.scene.getObjectByName(`Teleport_Point_001_Room_${roomNumber}_Spot_${spotNumber}_Target`)
                const infoTarget = this.experience.resources.items.mapModel.scene.getObjectByName(`Info_Point_001_Room_${roomNumber}_Spot_${spotNumber}_${infoNumber}_Target`)

                if (infoTarget) {
                    const target = new THREE.Vector3();
                    infoTarget.getWorldPosition(target);

                    const direction = new THREE.Vector3(0, 1, 0)
                    direction.applyQuaternion(infoTarget.getWorldQuaternion(new THREE.Quaternion())); // Convert to world direction

                    const distance = 0.05; // Or whatever you want
                    const cameraPosition = target.clone().sub(direction.multiplyScalar(distance));

                    this.placeholders.push({
                        position: cameraPosition,
                        target: target,
                        room: false,
                        location: false,
                        info: true,
                        placeholder: false,
                        id: `room_${roomNumber}_spot_${spotNumber}_${infoNumber}`,
                        spawn: `Teleport_Point_${spawn}`,
                        mesh: child
                    });
                }

                else {
                    this.placeholders.push({
                        position: spawnTarget.position,
                        target: {
                            x: child.clone().position.x,
                            y: spawnTarget.position.y,
                            z: child.clone().position.z
                        },
                        room: false,
                        location: false,
                        info: true,
                        placeholder: false,
                        id: `room_${roomNumber}_spot_${spotNumber}_${infoNumber}`,
                        spawn: `Teleport_Point_${spawn}`,
                        mesh: child
                    });
                }
            }

            if (child.name.includes("Link")) {
                this.placeholders.push({
                    url: child.userData.url,
                    mesh: child
                });
                // window.open(child.userData.url, '_blank').focus();
                // console.log(child.userData.url)
            }
        });
    }

    addEventListeners() {
        window.addEventListener('mousemove', (event) => this.onMouseMove(event), false);
        let dragThreshold = 5;
        let startX, startY;
        let isDragging = false;

        window.addEventListener('mousedown', (e) => {
            startX = e.clientX;
            startY = e.clientY;
            isDragging = false;
        });

        window.addEventListener('mousemove', (e) => {
            if (Math.abs(e.clientX - startX) > dragThreshold ||
                Math.abs(e.clientY - startY) > dragThreshold) {
                isDragging = true;
            }
        });

        window.addEventListener('click', (e) => {
            if (isDragging) {
                e.stopImmediatePropagation();
                e.preventDefault();
                return; // ignore accidental click
            }
            this.onClick(e); // your normal click handling
        }, true);
    }

    onMouseMove(event) {
        if (this.sidepanel) {
            // Need a slight offset when the sidepanel shows
            this.mouse.x = ((event.clientX + 282) / this.experience.sizes.width) * 2 - 1;
            this.mouse.y = -(event.clientY / this.experience.sizes.height) * 2 + 1;
        }

        else {
            // Convert the mouse position to normalized device coordinates
            this.mouse.x = (event.clientX / this.experience.sizes.width) * 2 - 1;
            this.mouse.y = -(event.clientY / this.experience.sizes.height) * 2 + 1;
        }

        // Check intersection on hover
        this.checkIntersection();
    }

    checkIntersection() {
        // Update raycaster with mouse and camera
        this.raycaster.setFromCamera(this.mouse, this.experience.camera.instance);

        // Build an array of meshes from our placeholders data
        // const placeholders = this.placeholders.map(item => item.mesh); // This is for the placeholders
        const meshes = [];
        this.experience.scene.traverse((child) => {
            if (child.isMesh) {
                meshes.push(child);
            }
        })
        // This only includes resources, excludes walls/tree etc.
        // this.experience.resources.items.mapModel.scene.traverse((child) => {
        //     if (child.isMesh) {
        //         meshes.push(child);
        //     }
        // })
        const intersects = this.raycaster.intersectObjects(meshes);

        const geometry = new THREE.BoxGeometry();
        const material = new THREE.MeshBasicMaterial({ color: 0x00ff00 });

        // Set the initial position
        if (intersects.length > 0 && intersects[0].object.visible) {
            if (intersects[0].object.name.includes("Info") || intersects[0].object.name.includes("Room")) {
                // Change cursor to pointer
                document.body.style.cursor = "pointer";
                // Set "isIntersecting"
                this.isIntersecting = true;

                // Overwrite material otherwise it affects the same material for all meshes
                if (intersects[0].object.name.includes("Room_Marker")) {

                }
                else {
                    if (intersects[0].object.name.includes("Info")) {
                        intersects[0].object.material = new THREE.MeshBasicMaterial({ map: intersects[0].object.material.map, color: 0x436cbe })
                    }

                    else {
                        intersects[0].object.material = new THREE.MeshStandardMaterial({
                            // color: 0xbad1ff,
                            color: 0x436cbe,
                            // emissive: 0xbad1ff,           // Emissive color (brighter blue)
                            // emissive: 0x003398,
                            // emissiveIntensity: 1,       // How strong the emissive glow is
                        })
                    }
                }
            }

            if (intersects[0].object.name.includes('Link')) {
                // Change cursor to pointer
                document.body.style.cursor = "pointer";
                // Set "isIntersecting"
                this.isIntersecting = true;
            }

        } if (intersects.length > 0) {
            if (!intersects[0].object.name.includes('Info') && !intersects[0].object.name.includes("Room") && !intersects[0].object.name.includes('Link')) {
                // Revert the color for all placeholders
                document.body.style.cursor = "default";
                this.isIntersecting = false
                meshes.forEach(mesh => {
                    mesh.traverse(child => {
                        if (child.isMesh && child.material) {
                            if (child.name.includes("Room_Marker")) {

                            }
                            else {
                                if (child.name.includes("Location_") && !child.name.includes("Spawn") && !child.name.includes("Target")) {
                                }
                                else {
                                    if (child.name.includes('Teleport') || child.name.includes('Info') || child.name.includes('Room')) {
                                        if (Array.isArray(child.material)) {
                                            child.material.forEach(mat => {
                                                if (mat && mat.color) mat.color.set(0xa5bfd7);
                                            });
                                        } else {
                                            if (child.material.color) child.material.color.set(0xa5bfd7);
                                            if (child.name.includes('Info')) {
                                                child.material = new THREE.MeshBasicMaterial({
                                                    map: child.material.map,
                                                })
                                            }

                                            else {
                                                child.material = new THREE.MeshStandardMaterial({
                                                    map: child.material.map,
                                                    metalness: 0,
                                                    roughness: 1,
                                                    color: 0x003398,
                                                    // emissive: 0x003398,           // Emissive color (brighter blue)
                                                    // emissiveIntensity: 1.5,       // How strong the emissive glow is
                                                })
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    });
                });
            }
            // meshes.forEach(mesh => console.log(mesh.material));
        }
    }

    onClick(event) {
        // Only process events on the canvas
        if (event.target.tagName !== 'CANVAS') return;

        // Update raycaster with mouse and camera
        this.raycaster.setFromCamera(this.mouse, this.experience.camera.instance);

        // Create an array of meshes to test against
        // const meshes = this.placeholders.map(item => item.mesh);
        const meshes = [];
        this.experience.scene.traverse((child) => {
            if (child.isMesh) {
                meshes.push(child);
            }
        })
        const intersects = this.raycaster.intersectObjects(meshes);
        // console.log(intersects);

        if (intersects.length > 0) {
            // Find the placeholder data object for the clicked mesh
            const intersectedMesh = intersects[0].object;
            const placeholderData = this.placeholders.find(item => item.mesh === intersectedMesh);

            if (placeholderData && intersectedMesh.visible) {
                this.handlePlaceholderClick(placeholderData);
            }
        }
    }

    handlePlaceholderClick(placeholderData) {
        // console.log(placeholderData)
        // Custom event to trigger function in CameraTransition
        document.dispatchEvent(new CustomEvent("placeholderClicked", {
            detail: {
                placeholder: placeholderData, // Pass the clicked placeholder
                event: event // Pass the original event if needed
            }
        }));

        if (placeholderData.info) {
            // Already set in SidePanel.js
            // document.querySelector(".webgl").style.transform = "translateX(-282px)" // Like for tracked points

            // Run through HTML to find the appropriate element to activate
            const point = `.point-${placeholderData.id}`
            const sidePanel = document.querySelector(point).parentElement.querySelector(".side-panel")
            // console.log(sidePanel)
            const menu = document.querySelector(".menu.primary")

            // console.log(document.querySelector(point).parentElement)
            document.querySelector(point).classList.add("clicked", "visible")
            // if (sidePanel) {
            //     sidePanel.classList.add("visible")
            //     menu.classList.add("hide")

            if (!sidePanel.classList.contains('visible')) {
                this.sidepanel = true
            }

            else {
                this.sidepanel = false
            }
        }

        if (placeholderData.url) {
            // console.log(placeholderData)
            window.open(placeholderData.url, '_blank').focus();
        }

        // Change the color of the clicked mesh to blue
        placeholderData.mesh.material.color.set(0x0000ff);

        // You can also use placeholderData.offset, placeholderData.target, etc.,
        // to implement additional behavior such as moving the camera.

        if (placeholderData.position) {
            // Need to reset the target specifically for home since we want to pivot around a fixed point
            if (placeholderData.id == 'home') {
                placeholderData.target.x = 0;
                placeholderData.target.y = 0;
                placeholderData.target.z = 0;
            }
            this.cameraControls.setLookAt( // This is basically, setPosition (camera position) and setTarget (center)
                placeholderData.position.x,
                placeholderData.position.y,
                placeholderData.position.z,
                placeholderData.target.x,
                placeholderData.target.y,
                placeholderData.target.z,
                true
            );
        }

        // Save state so it goes back to the previous "location" when exiting the info. Needs to be after the change ;)
        if (!placeholderData.info) {
            this.cameraControls.saveState()
        }
    }

    update() {
        // Fog system based on camera position. If underwater > fog.
        // Setup
        this.camPos = new THREE.Vector3();
        this.cameraControls.getPosition(this.camPos);

        // Determine if underwater
        const isUnderwater = this.camPos.y < 0;

        // Check for state change (only happens once when crossing)
        if (isUnderwater && !this.wasUnderwater) {
            // Just entered underwater → set start time
            this.startTime = this.time.elapsed;
        }

        this.underwaterFog = isUnderwater;
        this.wasUnderwater = isUnderwater; // Save previous state

        // Handle fog transition

        // else {

        // }
        // this.transition = true;


        if ((this.time.elapsed - this.startTime) <= 500 && this.underwaterFog) {
            if ((this.time.elapsed - this.startTime) >= 250 && this.transition) {
                const ogFogNear = 20;
                const ogFogFar = 85;
                const factorNear = 500 / ogFogNear; // Should go to 0
                const factorFar = 530 / ogFogFar;   // Should go to 5

                this.scene.fog = new THREE.Fog(
                    0x003249,
                    ogFogNear - ((this.time.elapsed - this.startTime) / factorNear) - 1,
                    ogFogFar - ((this.time.elapsed - this.startTime) / factorFar) + 3
                );

                // this.scene.fog = new THREE.Fog(0x054154, -10, 2)
            }
        } else {
            // Exiting or finished transition
            this.underwaterFog = false;
        }

        // console.log(this.cleanWater, this.underwaterFog, this.wasUnderwater)

        if (this.cleanWater) {
            if (this.locked) {
                this.locked = false;
                this.startTime = this.time.elapsed;
            }

            // this.startTime = this.time.elapsed;

            // console.log(this.cleanWater, this.time.elapsed, this.startTime)
            // console.log((this.time.elapsed - this.startTime) <= 500)

            if ((this.time.elapsed - this.startTime) <= 500) {
                // console.log(this.time.elapsed, this.startTime)

                const ogFogNear = -2;
                const ogFogFar = 6;
                const factorNear = 300 / ogFogNear;
                const factorFar = 200 / ogFogFar;

                this.scene.fog = new THREE.Fog(
                    0x003249,
                    // 0x1f313f,
                    ogFogNear + ((this.time.elapsed - this.startTime) / factorNear),
                    ogFogFar + ((this.time.elapsed - this.startTime) / factorFar)
                );

                // this.scene.fog = new THREE.Fog(0x054154, -10, 2)

                // this.scene.fog = new THREE.Fog(0x054154, 0, 12)
            }
        }
    }
}

